import { Alert } from '../shadcn'
import { cn } from '../../lib/utils'
import { PropsWithChildren } from 'react'

type AlertColor = 'blue' | 'red' | 'green' | 'gray' | 'amber'

type CalloutProps = PropsWithChildren<{
  color?: AlertColor
  className?: string
}>

export const ColoredAlert = ({ className, color = 'blue', children }: CalloutProps) => {
  return <Alert className={cn('border-none', getColorStyle(color), className)}>{children}</Alert>
}

const getColorStyle = (color: AlertColor) => {
  switch (color) {
    case 'blue':
      return 'bg-blue-100 text-blue-800 [&>svg]:text-blue-800'
    case 'red':
      return 'bg-red-100 text-red-800 [&>svg]:text-red-800'
    case 'green':
      return 'bg-green-100 text-green-800 [&>svg]:text-green-800'
    case 'gray':
      return 'bg-neutral-100 text-neutral-800 [&>svg]:text-neutral-800'
    case 'amber':
      return 'bg-amber-50 text-amber-800 [&>svg]:text-amber-800'
  }
}
